import { useEffect, useState } from "react";
import { apiClient } from "@/lib/auth";
import { FileText, Download } from "lucide-react";

export default function BillingHistory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.get("/billing/history").then(r => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="border border-border rounded-2xl bg-card overflow-hidden" data-testid="billing-history">
      <div className="px-5 py-4 border-b border-border flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] font-bold text-muted-foreground">Historique</p>
          <h3 className="font-bold text-base mt-1">Factures</h3>
        </div>
        <span className="text-xs text-muted-foreground">{items.length} facture{items.length > 1 ? "s" : ""}</span>
      </div>
      {loading ? (
        <div className="p-6 space-y-2">{[...Array(2)].map((_, i) => <div key={i} className="h-10 shimmer rounded" />)}</div>
      ) : items.length === 0 ? (
        <div className="px-6 py-12 text-center">
          <FileText className="h-8 w-8 mx-auto text-muted-foreground/50 mb-2" />
          <p className="text-sm text-muted-foreground">Aucune facture pour le moment.</p>
          <p className="text-xs text-muted-foreground mt-1">Elles apparaîtront ici dès votre premier paiement.</p>
        </div>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-[10px] uppercase tracking-[0.2em] font-bold text-muted-foreground bg-muted/20">
              <th className="px-5 py-3">Facture</th>
              <th className="px-5 py-3">Date</th>
              <th className="px-5 py-3">Plan</th>
              <th className="px-5 py-3">Montant</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.map(t => (
              <tr key={t.session_id} className="border-b border-border last:border-0 hover:bg-accent/30 transition-colors">
                <td className="px-5 py-3 font-mono text-xs">{t.invoice_number}</td>
                <td className="px-5 py-3">{new Date(t.created_at).toLocaleDateString("fr-FR")}</td>
                <td className="px-5 py-3 capitalize">{t.plan_id} · {t.billing_cycle === "annual" ? "annuel" : "mensuel"}</td>
                <td className="px-5 py-3 tabular-nums">{t.amount} {(t.currency || "eur").toUpperCase()}</td>
                <td className="px-5 py-3 text-right">
                  <button className="inline-flex items-center gap-1 text-xs font-semibold text-primary hover:underline">
                    <Download className="h-3 w-3" />PDF
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
